import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import './Header.css';

export const Header = () => {
  const { user, isAdmin, signOut } = useAuth();

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img src={logo} alt="Cemboo Logo" className="header-logo" />
          <div className="header-text">
            <h1 className="header-title">Cemboo RDD</h1>
            <span className="header-subtitle">Rapid Delivery Dashboard</span>
          </div>
        </div>
        
        <div className="header-right">
          {user && (
            <>
              <div className="user-info">
                <span className="user-email">{user.email}</span>
                {isAdmin && <span className="admin-badge">Admin</span>}
              </div>
              <button onClick={signOut} className="btn btn-secondary">
                Sign Out
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
